module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_1_after.jpg
// module id = 1193
// module chunks = 0